import SEO from "components/seo";
import Layout from "components/layout";
import CertifiedTranslation from "components/reusableComponents/certified-translation.js";
import React from "react";

export default function Index() {
  const title = "Certified Translation Services | Tomedes";
  const description =
    "Tomedes provides certified translation services to meet the certification requirements of jurisdictions worldwide, delivering certified translations in more than 100 languages.";
  const keywords =
    "Certified translation, certificate of translation, professional translation";
  const slug = "/certified-translation.php";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={slug}
      />
      <CertifiedTranslation />
    </Layout>
  );
}
